import React from 'react';

import { ActivatedSubscriptionInfo } from 'src/app/subscription/subscription-types';
import { SelectableOption } from 'src/common/components/selectable-option/selectable-option';
import { Text } from 'src/common/components/text/text';
import { PrivacyVisibility } from 'src/common/types/privacy';
import { calculateUpsellLink } from 'src/settings/utils/calculate-upsell-link';

import { VISIBILITY_OPTIONS } from '../../constants';
import { ContentSection } from '../content-section/content-section';
import { PrivacyAndSecurityLayout } from '../privacy-and-security/privacy-and-security-component';
import { UpsellLabel } from '../upsell-label/upsell-label';
import { WithUpsellLink } from '../with-upsell-link/with-upsell-link';

const calculateVisibilityUpsellLink = (isVideoLayout: boolean) =>
  calculateUpsellLink(
    isVideoLayout
      ? 'privacy-hideon-video-option'
      : 'privacy-hideon-user-option',
    isVideoLayout
  );

type PrivacyAndSecurityVisibilityProps = {
  currentPlan: ActivatedSubscriptionInfo | null;
  visibility: PrivacyVisibility;
  handleVisibilityChange: (value: PrivacyVisibility) => void;
  layout?: PrivacyAndSecurityLayout;
};

export const PrivacyAndSecurityVisibility = ({
  currentPlan,
  visibility,
  handleVisibilityChange,
  layout = 'generic',
}: PrivacyAndSecurityVisibilityProps) => (
  <ContentSection title="Visibility">
    {VISIBILITY_OPTIONS.map((option) => {
      const disabled =
        option.value === 'hidden_on_streamable' ? !currentPlan : false;
      return (
        <WithUpsellLink
          key={`upsell-link-for-${option.value}`}
          enableUpsell={disabled}
          upsellLink={calculateVisibilityUpsellLink(layout === 'video')}
        >
          <SelectableOption
            key={option.value}
            label={
              <UpsellLabel
                enableUpsell={disabled}
                label={option.label}
                planName="Basic"
              />
            }
            secondaryLabel={
              <Text variant="secondary">{option.description}</Text>
            }
            handleSelect={(event) => {
              handleVisibilityChange(
                event.currentTarget.value as PrivacyVisibility
              );
            }}
            isSelected={option.value === visibility}
            name="visibility"
            value={option.value}
            disabled={disabled}
          />
        </WithUpsellLink>
      );
    })}
  </ContentSection>
);
